export enum FundraisingBankDetailsType {
  DEFAULT = 'SWAN',
  TEMPLATE = 'TEMPLATE',
}

export type INewFundraisingUploadBankDetailsForm = {
  bankDetailsType: FundraisingBankDetailsType;
  bankDetailsFile?: string;
};
